/**
 * Provider for "geoFromIP" property
 * @module
 */
var GeoSource = require('core/plugins/sources/geo');

module.exports = {
  provides: 'location',

  // Source returns a deferred
  isAsync: true,

  getter: [
    function() {
      return GeoSource.getIPDerivedGeolocation();
    }
  ],
};
